module.exports = __webpack_public_path__ + "static/key-jurassic-050d79057acabc1cd972e8ac8ac12a68.webp";